import { RISK_GATE_STATUS } from '../api/constants';
import { getRiskGate } from '../api/riskGate';
import { getBffRequestBaseParams } from '../selectors/bff';
import { getRiskGateMetadata } from '../selectors/riskGate';
import { CheckoutState } from '../state';

const INVALID_BODY_ERROR = 'INVALID_BODY';

export const getIsUserGated = async (state: CheckoutState) => {
    const riskGateMetadata = getRiskGateMetadata(state);
    const { eventId, env } = getBffRequestBaseParams(state);

    try {
        const result = await getRiskGate({
            env,
            eventId,
            metadata: riskGateMetadata,
        });

        return result.body.status === RISK_GATE_STATUS.GATED;
    } catch (e) {
        return e.message === INVALID_BODY_ERROR;
    }
};
